import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.css'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate(
          '0.5s ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
  ],
})
export class NotFoundComponent implements OnInit {
  notFoundText: string = '404';
  letters: string[] = [];
  attemptedPath: string = '';
  letterDelays: string[] = [];

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.letters = this.notFoundText.split('');

    this.attemptedPath = window.location.pathname;
    this.letterDelays = this.letters.map(() => `${Math.random() * 0.5}s`);
  }

  goToHome(): void {
    this.router.navigate(['/home']);
  }
}
